import React, { useState } from "react";
import { CalendarPlus, Link2, Package } from "lucide-react";

import { Button } from "@/components/ui/button";
import SubmitPackageDialog from "./dialogs/SubmitPackageDialog";
import { isFeatureEnabled } from "../../../../services/flagsService";

interface ProfileActionButtonsProps {
  ownProfile: boolean;
  hasAuthor: boolean;
  onOpenAuthorLink: () => void;
}

const ProfileActionButtons: React.FC<ProfileActionButtonsProps> = ({
  ownProfile,
  hasAuthor,
  onOpenAuthorLink,
}) => {
  const [submitOpen, setSubmitOpen] = useState(false);

  if (!ownProfile) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {!hasAuthor && (
        <Button variant="outline" className="gap-2" onClick={onOpenAuthorLink}>
          <Link2 className="w-4 h-4" />
          Saytda sualım var
        </Button>
      )}
      {isFeatureEnabled('SUBMIT_PACKAGE') && (
        <>
          <Button variant="outline" className="gap-2" onClick={() => setSubmitOpen(true)}>
            <Package className="w-4 h-4" />
            Paket göndər
          </Button>

          <SubmitPackageDialog open={submitOpen} onOpenChange={setSubmitOpen} />
        </>
      )}
    </div>
  );
};

export default ProfileActionButtons;
